<template>
  <div class="sect-section">
    <div class="container">
      <h1 class="sect-title">Todos os Clãs de Vampiro: A Máscara</h1>
      <p class="lead text-center mb-4" style="color: #e9ecef;">
        Explore cada clã disponível em Vampiro A Máscara e encontre símbolos, apelidos e disciplinas para montar ficha de
        vampiro online com foco em V20, V5, Jyhad e crônicas personalizadas.
      </p>

      <div v-for="sectId in orderedSects" :key="sectId" class="mb-4">
        <h3 class="mt-3 mb-3" style="color: var(--vampire-gold);">{{ sectName(sectId) }}</h3>
        <div class="row">
          <div
            v-for="clan in sectClans(sectId)"
            :key="clan.id"
            class="col-md-4 mb-4"
          >
            <div class="card clan-card h-100" @click="$emit('show-clan-modal', clan)">
              <div class="card-body text-center">
                <div class="clan-symbol-container">
                  <template v-if="isImage(clan.symbol)">
                    <img :src="clan.symbol" :alt="`Emblema do clã ${clan.name} em Vampiro: A Máscara`" class="clan-symbol-image"
                      loading="lazy" />
                  </template>
                  <template v-else>
                    <div class="clan-symbol-emoji">{{ clan.symbol }}</div>
                  </template>
                </div>
                <h5 class="card-title mt-3">{{ clan.name }}</h5>
                <p class="card-text">{{ clan.nickname }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button class="btn btn-vampire" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clansData } from '../data/clans.js'

export default {
  name: 'AllClansView',
  computed: {
    orderedSects() {
      return ['camarilla', 'sabbat', 'anarquistas', 'independentes']
    }
  },
  methods: {
    sectClans(sectId) {
      const sect = clansData[sectId]
      return sect ? sect.clans : []
    },
    sectName(sectId) {
      const sect = clansData[sectId]
      return sect ? sect.name : sectId
    },
    isImage(symbol) {
      return typeof symbol === 'string' && (
        symbol.startsWith('http') || symbol.startsWith('data:') || symbol.includes('/') || /\.(png|jpe?g|gif|svg)$/i.test(symbol)
      )
    }
  }
}
</script>

<style scoped>
.clan-symbol-container {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.clan-symbol-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.clan-symbol-emoji {
  font-size: 3rem;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.8));
}
</style>

